import { Card, Col, Row } from "react-bootstrap";

interface IEpaCard {
  title?: string;
  content?: JSX.Element;
  subStatusContent?: JSX.Element;
}

export const TrackerCard = ({ title, content, subStatusContent }: IEpaCard) => (
  <Card className="flex-fill w-100">
    <Card.Header>
      <Card.Title>
        <Row>
          <Col className="col-12 col-md-6">
            <h2>{title}</h2>
          </Col>
          <Col className="col-12 col-md-6 text-end">{subStatusContent}</Col>
        </Row>
      </Card.Title>
    </Card.Header>
    <Card.Body className="pt-0">{content}</Card.Body>
  </Card>
);
